<div *ngIf="needsAddressVerification" class="address-verification-banner" role="status" data-testid="address-banner">
  <span class="material-icons address-verification-banner__icon" aria-hidden="true">location_off</span>
  <span>We couldn't verify your address on the map. Until it's verified, we may not be able to send you jobs near you.</span>
  <a class="address-verification-banner__link" routerLink="/manageaccount" [queryParams]="{ tab: 'profile' }" fragment="address" data-testid="address-banner-verify-link">Verify your address</a>
</div>
